import OTPForm from "@/modules/auth/otp/ui/components/OTPForm";

export default function OtpPage() {
  return (
    <div className="flex items-center justify-center min-h-screen bg-muted">
      <div className="w-full max-w-md p-8">
        <OTPForm />
      </div>
    </div>
  )
}
